import { Alert, Box, Typography } from '@mui/material';
import { useAppSelector } from '../../utils/hooks';
import Footernav from 'src/components/Footernav';
import PersonSummary from './PersonSummary';
import { useEffect, useState } from 'react';
import OrderDialog from './OrderDialog';

export default function InsuranceSummary() {
  const { persons } = useAppSelector((state) => state?.contribution);
  const [open, setOpen] = useState(false);
  const { isColorBlindMode, mandant } = useAppSelector((state) => state.config);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <OrderDialog open={open} setOpen={setOpen} />
      {persons.map((_, index) => (
        <PersonSummary key={index} index={index + 1} />
      ))}
      <Alert
        severity="info"
        sx={{
          width: '100%',
          alignItems: 'center',
          marginY: 3,
          ...(isColorBlindMode && {
            backgroundColor: '#FFF',
            color: 'black',
            border: '1px solid #000000',
            '& .MuiAlert-icon': {
              color: 'black',
            },
          }),
        }}
      >
        <Box>
          {isColorBlindMode ? (
            <Box
              sx={{
                fontFamily: 'Helvetica Neue',
                fontSize: '14px',
                lineHeight: '100%',
                letterSpacing: '0%',
              }}
            >
              <Box sx={{ fontWeight: 700, marginBottom: 1 }}>
                Wenn Sie auf "KOSTENPFLICHTIG BEANTRAGEN" klicken, sagen Sie:
              </Box>
              <Box
                component="ul"
                sx={{
                  margin: 0,
                  paddingLeft: '20px',
                  fontWeight: 700,
                  '& li': {
                    marginBottom: 0.5,
                    '&:last-child': {
                      marginBottom: 0,
                    },
                  },
                }}
              >
                <li>
                  Ich bestätige: Alles, was ich in meinem Antrag und zu meiner
                  Gesundheit gesagt habe, stimmt. Es ist alles richtig und
                  nichts fehlt.
                </li>
                <li>
                  Ich bin einverstanden: Mein Antrag wird per Computer an die
                  SDK Krankenversicherung geschickt. Der Antrag ist verbindlich.
                  Das heißt, ich muss das dann so&nbsp;machen.
                </li>
                <li>
                  Ich weiß, dass für mich Kosten entstehen, wenn die
                  Versicherung meinen Antrag annimmt. Die Kosten sind der
                  Versicherungs-Beitrag, der einmal in jedem Monat zu bezahlen
                  ist.
                </li>
              </Box>
            </Box>
          ) : (
            <>
              <Typography>
                Hinweis: Wenn Sie kostenpflichtig beantragen, erhalten Sie{' '}
                {mandant === 'sdk'
                  ? 'einen Versicherungsantrag'
                  : mandant === 'vmk'
                  ? 'einen Antrag'
                  : 'eine Versicherungsbestätigung'}{' '}
                als PDF zum Speichern oder Ausdrucken.
              </Typography>
              <br />
              <Typography>
                Der Versicherer speichert Ihre Antragsunterlagen ab.
              </Typography>
            </>
          )}
        </Box>
      </Alert>
      <Footernav
        disableNext={false}
        nextText={'Kostenpflichtig beantragen'}
        onNext={() => {
          setOpen(true);
        }}
      />
    </Box>
  );
}
